import Vue from 'vue/dist/vue.min.js';
import template from 'shared/meter-selector-step-bar.hbs';

Vue.component(
    "ms-step-bar",
    {
        props: {
            steps: Array, 
            onChange: Function,
            current: Number,
            selectedValues: { type: Array, default: [] },
            offset: { type: Number, default: 50 },
        },
        data(){
            return {
                rootClasses:  {
                    'noCenterAlign' : true
                },
                onResizeFlag: false,
                isMouseDown: false,
            };
        },
        watch: {
            current: {
                handler() {
                    this.onResize();
                },
                immediate: true
            },
            steps: {
                handler() {
                    this.onResizeFlag = true;
                },
                immediate: true
            }
        },
        computed:  {
            getSteps() {
                const ctx = this;
                return this.steps.map((s, i) => {
                    const classes = {
                        'ms-step-bar_item' : true,
                        'ms-step-bar_item--selected' : i === ctx.current,
                        'ms-step-bar_item--checked' : i <= ctx.maxStep
                    };

                    return {...s, selectedValue: ctx.selectedValues[i], classes };
                })
            },
            maxStep() {
                return (this.selectedValues && this.selectedValues.length) || 0;
            }
        },
        mounted() {
            window.addEventListener('resize', this.onResize);

            this.$refs.list.addEventListener('touchstart', this.startDrag);
            this.$refs.list.addEventListener('mousedown', this.startDrag);

            document.addEventListener('mouseup', this.endDrag);
            document.addEventListener('touchend', this.endDrag);

            document.addEventListener('mousemove', this.moveDrag);
            document.addEventListener('touchmove', this.moveDrag);
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.onResize);

            this.$refs.list.removeEventListener('touchstart', this.startDrag);
            this.$refs.list.removeEventListener('mousedown', this.startDrag);

            document.removeEventListener('mouseup', this.endDrag);
            document.removeEventListener('touchend', this.endDrag);

            document.removeEventListener('mousemove', this.moveDrag);
            document.removeEventListener('touchmove', this.moveDrag);
        },
        updated(){
            if (this.onResizeFlag) {
                this.onResize();
                this.onResizeFlag = false;
            }
        },
        methods: {
            onResize(){
                let diff = 0;

                const w = window.innerWidth;
                const list = this.$refs.list;
                const children = (list && list.childNodes) || [];
                const last = children[children.length - 1];
                const end = last ? (last.offsetWidth + last.offsetLeft + this.offset) : 0;

                if (w < end) {
                    const ldiff =  (end - w) * - 1;

                    const mw = w / 2;
                    const selected = children[this.current];
                    const selectedEnd = selected && selected.offsetWidth + selected.offsetLeft;

                    if (selected && mw < selectedEnd) {
                        diff = (selectedEnd - mw) * -1;
                    }

                    if (ldiff > diff) {
                        diff = ldiff 
                    }
                }

                if (list) {
                  list.style.transform = `translateX(${diff}px)`;
                }

                this.rootClasses =  {
                    ...this.rootClasses,
                    'noCenterAlign': end === 0 ? true : w < end,
                };
            },
            hasSelectedValue(i){
                return this.selectedValues && this.selectedValues[i];
            },
            reset(defaultCurrent = 0){
                this.onChange && this.onChange(defaultCurrent);
            },
            onClickStep(i){
                if (i > this.maxStep){
                    return;
                }

                this.onChange && this.onChange(i);
            },
            startDrag(){
                this.isMouseDown = true;
            },
            endDrag(){
                this.isMouseDown = false;
            },
            moveDrag(e){
                const elm = this.$refs.list;
                if (!elm || !this.isMouseDown) {
                    return;
                }

                const clientX = e.clientX || (e.touches[0] || e.changedTouches[0] || {}).pageX;

                if (elm.previousClientX !== undefined) {
                    const diff = clientX - elm.previousClientX;
                    const styleFound = elm.style.transform.match(/translateX\((.*)px\)/i) || [];
                    const x = styleFound[1] ? parseInt(styleFound[1]) : 0;

                    const children = elm.childNodes || [];
                    const last = children[children.length - 1];
                    const w = window.innerWidth;
                    const end = last ? (last.offsetWidth + last.offsetLeft + this.offset) : 0;
                    const maxX = (end - w) * -1;

                    const add =  10;
                    let nx = x;

                    if (diff > 0) {
                        nx = x+add;

                        if (nx > 0) {
                            nx = 0;
                        }
                    } else if (diff < 0 && maxX < 0) {
                        nx = x-add;

                        if (nx < maxX) {
                            nx = maxX;
                        }
                    }

                    const transformStyle = `translateX(${nx}px)`;

                    if (styleFound[0]) {
                        elm.style.transform = elm.style.transform.replace(styleFound[0], transformStyle);
                    } else {
                        elm.style.transform += 	transformStyle + ';' ;
                    }
                }

                elm.previousClientX = clientX;
            }
        }, 
        template
    }
);
